// Importable registry mapping a dynamic form's id to its live
// DynamicFormHandle (the extended handle from @scientist/dynamic-form-renderer,
// exposing getFields/getVisibleFields/getValue/getFieldValue/getValidation/
// getFieldValidation). Lets feature code read a rendered form's live state by
// id — the modern-ESM replacement for the old `$.alpaca($form)` lookup.

const forms = new Map();

export function registerForm(id, handle) {
  forms.set(id, handle);
}

export function unregisterForm(id) {
  forms.delete(id);
}

// Returns the handle for `id`, or undefined if no form with that id is mounted.
export function getForm(id) {
  return forms.get(id);
}

// Returns a snapshot copy of the id → handle map (mutating it won't affect the
// registry).
export function getForms() {
  return new Map(forms);
}

window.dynamicFormRegistry = {
  registerForm,
  unregisterForm,
  getForm,
  getForms,
};
